const solutionType = require('./solution-types');

module.exports = [
  //sports
  {
    url: '/solutions/sports-highlights/',
    img: '/uploads/next/solutions/sports-highlights/hero.jpg',
    title: 'Automated sports highlights generation',
    about: 'Next level of post-production efficiency',
    groupKey: solutionType.sports.key,
  },
  {
    url: '/solutions/esports-highlights/',
    img: '/uploads/next/solutions/esports-highlights/hero.jpg',
    title: 'Automated Esports Games Highlights Generation',
    about: 'Next level of post-production efficiency',
    groupKey: solutionType.sports.key,
  },

  //promotion
  {
    url: '/solutions/video-cropping/',
    img: '/uploads/next/solutions/video-cropping/hero.jpg',
    title: 'Vertical media adaptation for social networks',
    about: 'Next level of adaptation efficiency',
    groupKey: solutionType.promotion.key,
  },
  {
    url: '/solutions/automated-video-summarization/',
    img: '/uploads/next/solutions/video-summary/hero.jpg',
    title: 'Automated video summarization',
    about: 'Next level of post-production efficiency',
    groupKey: solutionType.promotion.key,
  },
  {
    url: '/solutions/video-clipping/',
    img: '/uploads/next/solutions/video-clipping/hero.jpg',
    title: 'Automated video clipping with AI',
    about: 'Next level of video editing automation',
    groupKey: solutionType.promotion.key,
  },

  //ott
  {
    url: '/solutions/automated-subtitle-generation/',
    img: '/uploads/next/solutions/auto-subtitling/hero.jpg',
    title: 'Automated Subtitle Generation',
    about: 'Next level of post-production efficiency',
    groupKey: solutionType.ott.key,
  },
  {
    url: '/solutions/automated-movie-trailers/',
    img: '/uploads/next/solutions/movie-trailers/hero.jpg',
    title: 'Automated Movie Trailers Generation',
    about: 'Next level of post-production efficiency',
    groupKey: solutionType.ott.key,
  },
  {
    url: '/solutions/end-credits-detection/',
    img: '/uploads/next/solutions/safe-skip/hero.jpg',
    title: 'Safe intro and outro skip',
    about: 'Next level of operational efficiency',
    groupKey: solutionType.ott.key,
  },
  {
    url: '/solutions/metadata-recognition/',
    img: '/uploads/next/solutions/celebrity-listing/hero.jpg',
    title: 'AI-based celebrity listing automation',
    about: 'Next level of metadata automation efficiency',
    groupKey: solutionType.ott.key,
  },
  {
    url: '/solutions/automated-nudity-filtering/',
    img: '/uploads/next/solutions/nudity-filtering/hero.jpg',
    title: 'Automated nudity filtering for movies and user-generated video',
    about: 'Next level of compliance automation',
    groupKey: solutionType.ott.key,
  },

  //advertising
  {
    url: '/solutions/video-ad-detection/',
    img: '/uploads/next/solutions/ad-detection/hero.jpg',
    title: 'Automated video ad detection and replacement',
    about: 'Next level of advertising efficiency',
    groupKey: solutionType.advertising.key,
  },
  {
    url: '/solutions/video-ad-insertion/',
    img: '/uploads/next/solutions/ad-insertion/hero.jpg',
    title: 'Safe context-aware video ad insertion',
    about: 'Next level of operational efficiency',
    groupKey: solutionType.advertising.key,
  },
  {
    url: '/solutions/logo-detection/',
    img: '/uploads/next/solutions/logo-detection/hero.jpg',
    title: 'Logo detection solution for outstanding branding',
    about: 'Next level of monitoring efficiency',
    groupKey: solutionType.advertising.key,
  },
];
